module.exports = __webpack_public_path__ + "static/images/styles/images/table/table-row-own-left.e62e7275.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/table/table-row-own-left.png
// module id = 3842
// module chunks = 11